import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/FloatingContactButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/index.css");
